import React from 'preact/compat';
import { twMerge } from 'tailwind-merge';

import ShopListItem, { type ShopListItemProps } from './ShopListItem';

export interface ShopListProps extends Omit<ShopListItemProps, 'device'> {
  devices: ShopListItemProps['device'][];
  class?: string;
  disclaimerClass?: string;
}

export default function ShopList({
  devices,
  class: className,
  disclaimerClass: disclaimerClassName,
  ...other
}: ShopListProps) {
  const sortedDevices = React.useMemo(
    () =>
      devices.sort((a, b) => {
        // first sort by match
        if ((a.match != null || b.match != null) && a.match !== b.match) return (b.match ?? 0) - (a.match ?? 0);

        // then sort by name
        return a.data.title.localeCompare(b.data.title);
      }),
    [devices]
  );

  return (
    <>
      <div className={twMerge('pb-4 flex items-stretch space-x-4 overflow-x-auto', className)}>
        {sortedDevices.map((device, index) => (
          <ShopListItem key={index} device={device} {...other} />
        ))}
      </div>
    </>
  );
}
